/**CORE LIBRARIES IMPORT */
import React from "react";

/**COMPONENTS IMPORT */
import PhotoPlaceholder from "./PhotoPlaceholder";

/**DATA IMPORT */
import { ALLERGENS, formatMenuPrice } from "../data/menu";

/**
 * Display-only menu item (no ordering). Uses the template's gradient-framed
 * `.img-wrapper` and card typography.
 */
const MenuItemCard = ({ item }) => {
  const price = formatMenuPrice(item.price);
  const unavailable = item.available === false;

  return (
    <article className={`menu-item ${unavailable ? "is-unavailable" : ""}`}>
      <div className="img-wrapper menu-item-media">
        {item.image ? (
          <img src={item.image.src} alt={item.image.alt || item.name} loading="lazy" decoding="async" />
        ) : (
          <PhotoPlaceholder ratio="4 / 3" />
        )}
        {item.featuredLabel && <span className="menu-item-badge">{item.featuredLabel}</span>}
        {unavailable && <span className="menu-item-status">Currently unavailable</span>}
      </div>

      <div className="menu-item-body">
        <div className="menu-item-head">
          <h3 className="menu-item-name">{item.name}</h3>
          <p className="menu-item-price">
            {price || <span className="is-tbc">Price to be confirmed</span>}
          </p>
        </div>

        {item.description && <p className="section-text menu-item-desc">{item.description}</p>}

        {item.allergens?.length > 0 && (
          <p className="menu-item-allergens">
            <span className="menu-item-allergens-label">Allergens:</span>{" "}
            {item.allergens.map((code, i) => (
              <React.Fragment key={code}>
                {i > 0 && ", "}
                <abbr title={ALLERGENS[code]}>{code}</abbr>
                <span className="sr-only"> ({ALLERGENS[code]})</span>
              </React.Fragment>
            ))}
          </p>
        )}
      </div>
    </article>
  );
};

export default MenuItemCard;
